import instance from 'utils/axios.utils';

const payout = {
  getManyPayout: (data?) => {
    let promise = new Promise((resolve, reject) => {
      let url:any = 'payout/get_all_payout';
      instance()
        .post(url, data)
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          if (error.response) {
            reject(error.response.data.message);
          } else {
            reject(error);
          }
        });
    });
    return promise;
  },
  editPayout: (body?) => {
    let promise = new Promise((resolve, reject) => {
      let url = `payout/edit_payout`;
      instance()
        .post(url, body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          if (error.response) {
            reject(error.response.data.message);
          } else {
            reject(error);
          }
        });
    });
    return promise;
  },
};

export default payout;
